export default __webpack_public_path__ + "0c5328a3cba6b2548a571fecab6b4178.svg";